
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Constants } from 'src/app/models/constants';

import { BehaviorSubject, Observable, Subject, of } from 'rxjs';

import { InvoiceDataInformation } from 'src/app/models/invoice-data-information';

import { SelectEntity } from 'src/app/postlogin/onboarding/invoice-customisation/invoice-customisation.component';
import { StorageService } from '../storage.service';
@Injectable({
    providedIn: 'root',
})
export class SharedService {
    private entityChangeEmitter = new Subject<any>();
    private screen: string;
    private countryNameChangeEmitter = new BehaviorSubject<string>('');
    private countryCodeChangeEmitter = new BehaviorSubject<string>('');
    private countryFlagLocationChangeEmitter = new BehaviorSubject<string>('');
    private groupCodeChangeEmitter = new BehaviorSubject<string>('');
    private AllgroupCodeChangeEmitter = new BehaviorSubject<string>('');
    private ConfigParamDataChangeEmitter = new BehaviorSubject<any>(false);
    private activeItemChangeEmitter = new BehaviorSubject<string>('');
    private AllClientFeedbackgroupDetailsEmitter = new BehaviorSubject<string>('');
    private invoiceTabEnableDisableChangeEmitter = new BehaviorSubject<any>(null);
    countryName: any;
    countryCode: any;
    groupCode: any;
    feedbackgroupDetails: any;
    selectedCountryCode: any;
    selectedCountryName: any;
    flagLocation: string;
    ConfigParamData: any;
    disableDms = false;
    toggleInvoiceTabVal: any;
    constructor(private http: HttpClient, private storageService: StorageService) { }

    downloadFile(fileName, baseStorage, fileStore, blobStore, container, path): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/downloadFiles`;

        let params = new HttpParams();
        params = params.append('fileName', fileName);
        params = params.append('baseStorage', baseStorage);
        params = params.append('fileStore', fileStore);
        params = params.append('blobStore', blobStore);
        params = params.append('container', container);
        params = params.append('path', path);

        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });

    }

    //TODO :: to be removed in future sprints
    downloadReport(fileId, type, path, fileName): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/downloadReport`;

        let params = new HttpParams();
        params = params.append('fileId', fileId);
        params = params.append('type', type);
        params = params.append('path', path);
        params = params.append('fileName', fileName);
        //params=params.append('fileType',fileType);

        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }

    //service implementation for download MoF error and success report


    getParentEntities(tenantGroupId): Observable<any> {
        const url = Constants.APP_BASE_API_URL + '/group/entities?tenantGroupId=' + tenantGroupId;
        return this.http.get<any>(url);
    }

    getEntytiesFromEntityMasterTable(): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/getAllEntitiesFromEntityMasterTable`;
        return this.http.get<SelectEntity[]>(url, { responseType: 'json' })

    }

    fetchModuleType(): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/fetchModuleType`;
        return this.http.get(url);
    }

    emitEntityChange() {
        this.entityChangeEmitter.next(this.screen);
    }

    entityChangeObserve() {
        return this.entityChangeEmitter.asObservable();
    }

    setScreen(screen) {
        this.screen = screen;
    }

    getReportParamDetails(requestId: string): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/getReportParamDetails`;
        let reqs = new HttpParams();

        reqs = reqs.append('requestId', requestId);

        return this.http.post<any>(url, reqs);
    }


    getInvoiceData() {
        const url = `${Constants.APP_BASE_API_URL}/getAllInvoiceData`;
        return this.http.get<InvoiceDataInformation[]>(url)
    }

    getPdfCustomisationData() {
        const url = `${Constants.APP_BASE_API_URL}/fetchPDFCustomisationData`;
        return this.http.get<any>(url)
    }


    //for downloading file for invoice customization.
    downloadFileForInvoiceCustomization(fileId, fileName, directory) {
        const url = `${Constants.APP_BASE_API_URL}/downloadFileForInvoiceCustomization`;

        let params = new HttpParams();
        params = params.append('fileId', fileId);
        params = params.append('fileName', fileName);
        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }
    
    downloadCustomizedTemplate(fileId, fileName, directory) {
        const url = `${Constants.APP_BASE_API_URL}/downloadCustomizedTemplate`;

        let params = new HttpParams();
        params = params.append('fileId', fileId);
        params = params.append('fileName', fileName);
        params = params.append('directory', directory);
        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }



    //for show preview sample data.

    showPreviewSamplaeData(fileId, fileName): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/showPreviewDataForCustomization`;
        let params = new HttpParams();
        const httpOptions = {
            'responseType': 'blob' as 'json'
        };
        params = params.append('fileId', fileId);
        params = params.append('fileName', fileName);
        return this.http.post(url, params, httpOptions);
    }

    deleteInvoiceDataByEntityName(entityName: string): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/deactivateInvoiceDataRowByEntityName/${entityName}`;
        let reqs = new HttpParams();
        //reqs = reqs.append('entityName', entityName);
        return this.http.delete<any>(url);
    }

    getInvoiceDataByEntityName(entityName: string, isActive: Boolean): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/getAllInvoiceDataBasedOnEntity/${entityName}/${isActive}`;
        let reqs = new HttpParams();
        reqs = reqs.append('entityName', entityName);
        reqs = reqs.append('isActive', true);
        // reqs = reqs.append('sourceIdentifier',sourceIdentifier);
        return this.http.post<any>(url, reqs);
    }

    private enagagementCode = new BehaviorSubject<string>('');
    selectedEnagagementCode = this.enagagementCode.asObservable();
    updateSelectedEnagagementCode(name: string) {
        this.enagagementCode.next(name);
    }

    saveAndUploadTemplateData(data: any) {
        const url = `${Constants.APP_BASE_API_URL}/saveAndUploadPdfTemplate`;
        const formData: FormData = new FormData();
        const jsonBlob = new Blob([JSON.stringify(data)], { type: 'application/json' });
        formData.append('data', jsonBlob);
        formData.append('file', new Blob(), '');
        return this.http.post<any>(url, formData);
    }

    activateOrInActivatePDFTemplate(fileIds, operationType) {
        const url = `${Constants.APP_BASE_API_URL}/activateOrInActivatePDFTemplate`;
        let reqs = new HttpParams();
        reqs = reqs.append('fileIds', fileIds);
        reqs = reqs.append('operationType', operationType);
        return this.http.post<any>(url, reqs);
    }

    emitCountryCodeChange() {
        this.countryCodeChangeEmitter.next(this.countryCode);
    }
    countryCodeChangeObserve() {
        return this.countryCodeChangeEmitter.asObservable();
    }

    emitActiveItemChange(val) {
        this.activeItemChangeEmitter.next(val);
    }
    activeItemChangeObserve() {
        return this.activeItemChangeEmitter.asObservable();
    }
    setcountryCode(countryCode) {
        this.countryCode = countryCode
    }

    emitCountryNameChange() {
        this.countryNameChangeEmitter.next(this.countryName);
    }
    countryNameChangeObserve() {
        return this.countryNameChangeEmitter.asObservable();
    }
    setcountryName(countryName) {
        this.countryName = countryName
    }

    emitCountryFlagLocationChange() {
        this.countryFlagLocationChangeEmitter.next(this.flagLocation);
    }
    countryFlagLocationChangeObserve() {
        return this.countryFlagLocationChangeEmitter.asObservable();
    }
    setCountryFlagLocation(flagLocation) {
        this.flagLocation = flagLocation
    }

    private responseSubject = new Subject<string>();
    get response$(): Observable<string> {

        return this.responseSubject.asObservable();
    }

    handleFileUploaded(infoResponse: string) {

        this.responseSubject.next(infoResponse);
    }



    getAllGroupCodes() {

        let url = `${Constants.KSA_ADMIN_BASE_API_URL}/getAllGroupCodes.do`;
        return this.http.post<any>(url, null);
    }

    syncRedisData(date: string) {
        let url = `${Constants.APP_BASE_API_URL}/syncRedis`;
        let params = new HttpParams();
        if (date) {
            params = params.append('selectedMonthAndYear', date);
            return this.http.post<any>(url, params, { responseType: 'text' as 'json' });
        }
    }

    switchGroupCodes(data, newGroupCode) {
        let reqdata = JSON.stringify(data)
        const httpOptions = {
            headers: new HttpHeaders({
                'groupCode': newGroupCode,
                'content-type': 'application/json'
            })
        };
        let url = `${Constants.KSA_ADMIN_BASE_API_URL}/switchGroupCode.do`;
        return this.http.post<any>(url, reqdata, httpOptions);
    }

    setAllGroupCodes(groupCode) {
        this.groupCode = groupCode;
    }

    emitAllGroupCodes() {
        this.AllgroupCodeChangeEmitter.next(this.groupCode);
    }

    AlgroupCodeChangeObserve() {
        return this.AllgroupCodeChangeEmitter.asObservable();
    }

    setGroupCOde(groupCode) {
        this.groupCode = groupCode;
    }

    emitgroupCodeChange() {
        this.groupCodeChangeEmitter.next(this.groupCode);
    }

    groupCodeChangeObserve() {
        return this.groupCodeChangeEmitter.asObservable();
    }

    // 

    setConfigParamData(disableDms) {
        this.disableDms = disableDms;
    }

    emitConfigParamDataChange() {
        this.ConfigParamDataChangeEmitter.next(this.disableDms);
    }

    ConfigParamDataeChangeObserve() {
        return this.ConfigParamDataChangeEmitter.asObservable();
    }

    private Clicksubject = new Subject<void>();
    sendClickEvent() {
        this.Clicksubject.next();
    }
    getClickEvent(): Observable<any> {
        return this.Clicksubject.asObservable();
    }

    enableClientFeedback(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getenableFeedback().subscribe((res: any) => {
                if (res?.additionalPermission == "Feedback") {
                    resolve(res)
                } else {
                    reject({ "message": "error while fetching" });
                }
            }, (error) => {
                console.log(error);
                reject({ "message": "error while fetching", "error": error });
            });

        });
    }

    getenableFeedback() {
        let url = `${Constants.APP_BASE_API_URL}/enableClientFeedback`;
        let header = new HttpHeaders({ 'userId': this.storageService.decodeValue("UserId") });
        return this.http.get<any>(url, { headers: header });
    }

    setClientFeedbackgroupDetails(groupDetails) {
        this.feedbackgroupDetails = groupDetails;
    }

    emitsetClientFeedbackgroupDetails() {
        this.AllClientFeedbackgroupDetailsEmitter.next(this.feedbackgroupDetails);
    }

    ClientFeedbackgroupDetailsObserve() {
        return this.AllClientFeedbackgroupDetailsEmitter.asObservable();
    }

    invoiceTabEnableDisableEmitChange(val) {
        this.invoiceTabEnableDisableChangeEmitter.next(val);
    }
    invoiceTabEnableDisableChangeObserve() {
        return this.invoiceTabEnableDisableChangeEmitter.asObservable();
    }
}
